// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b701758c","726":"2cd7c162"}[chunkId] + ".chunk.js";
};